import { parseLibrary } from 'api/parsers/parseLibrary';
import { fetch } from 'api/typedFetch';

export const getData = async (id: string) => {
  const response = await fetch('GET_IMAGE_LIBRARY', { params: new URLSearchParams({ app_id: id, format: 'json' }) });

  const data = await response.json();

  return Object.values(data.items)
    .map((item) => {
      return Object.keys(item).map((key) => {
        return parseLibrary(item[key]);
      });
    })
    .flat();
};
